var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer row"},[_c('div',{staticClass:"col-12 text-right"},[_vm._v(" ProduceIT © 2022 K3Net Kft. ")])])
}]

export { render, staticRenderFns }